import React from 'react'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Video, VideoPlayer } from 'widgets/Video'

import { useMaxWidth } from 'hooks/useMaxWidth'

import commonStyles from 'utils/styles/commonStyles'

import { FileType } from 'types/file'

import { MediaPlaceholder } from './MediaPlaceholder'

interface Props {
  fileUrl?: string
  handleVideoLoaded?: (videoPlayer: VideoPlayer) => void
  isMuted: boolean
  type?: FileType
}

export const MediaPreview = ({ fileUrl, handleVideoLoaded, isMuted, type }: Props) => {
  const { width, height } = useMaxWidth()

  let content = <MediaPlaceholder />

  if (fileUrl) {
    switch (type) {
      case 'image':
        content = (
          <Image source={{ uri: fileUrl }} resizeMode='cover' style={commonStyles.fullSize} />
        )
        break
      case 'video':
        content = (
          <Video
            source={fileUrl}
            width={width}
            height={height}
            muted={isMuted}
            handleLoaded={handleVideoLoaded}
          />
        )
        break
      default:
        break
    }
  }

  return (
    <Box width='100%' height='100%'>
      {content}
    </Box>
  )
}
